'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _elementConstants = require('../../../../common/elements/elementConstants');

var ELEMENT_ACTION_TYPES = _interopRequireWildcard(_elementConstants);

var _reactRouterRedux = require('react-router-redux');

var _selectionConstants = require('../../../../common/elements/selectionConstants');

var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);

var _elementCountConstants = require('../../../user/elementCount/elementCountConstants');

var ELEMENT_COUNT_ACTION_TYPES = _interopRequireWildcard(_elementCountConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
var actionHasUndoProperties = function actionHasUndoProperties(action) {
    // don't add other people's actions
    if (action.remote) return false;

    // don't add existing undo actions to the stack
    if (action.isUndo) return false;
    if (action.isRedo) return false;

    // add regular location change actions to the stack
    if (action.type === _reactRouterRedux.LOCATION_CHANGE) return true;
    // add things with a transaction id will be added to the stack
    if (action.transactionId) return true;

    // default to not adding actions to stack
    return false;
};

var stateHasElement = function stateHasElement(state, elementId) {
    return state.hasIn(['elements', elementId]);
};
var stateHasSomeElements = function stateHasSomeElements(state, elementIds) {
    return elementIds.some(function (elementId) {
        return state.hasIn(['elements', elementId]);
    });
};
var canUndoMultiMoveAction = function canUndoMultiMoveAction(state, action) {
    return stateHasSomeElements(state, action.moves.map(function (move) {
        return move.id;
    }));
};
var canUndoMoveAction = function canUndoMoveAction(state, action) {
    return stateHasElement(state, action.id);
};
var canUndoUpdateAction = function canUndoUpdateAction(state, action) {
    return stateHasSomeElements(state, action.updates.map(function (update) {
        return update.id;
    }));
};
var canUndoRouteChange = function canUndoRouteChange(state, action) {
    return !!state.get('routing').locationBeforeTransitions && action.payload && action.payload.action !== 'REPLACE';
};

var actionCanUndo = function actionCanUndo(state, action) {
    switch (action.type) {
        case ELEMENT_ACTION_TYPES.ELEMENT_MOVE_AND_UPDATE:
            return canUndoMoveAction(state, action);
        case ELEMENT_ACTION_TYPES.ELEMENT_MOVE_MULTI:
            return canUndoMultiMoveAction(state, action);
        case ELEMENT_ACTION_TYPES.ELEMENT_UPDATE:
            return canUndoUpdateAction(state, action);
        case _reactRouterRedux.LOCATION_CHANGE:
            return canUndoRouteChange(state, action);
        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
        case ELEMENT_ACTION_TYPES.ELEMENT_CREATE:
        case ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_INCREAESE:
        case ELEMENT_COUNT_ACTION_TYPES.ELEMENT_COUNT_DECREASE:
            return true;
        default:
            return false;
    }
};

exports.default = function (store, action) {
    return actionHasUndoProperties(action) && actionCanUndo(store.getState(), action);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/middleware/shouldAddUndo.js
// module id = 2146
// module chunks = 0